export default __webpack_public_path__ + "static/media/gif3_slow.736d0b91.gif";